import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '3x',
});

export const districtMessage = css({
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxBlue500',
  margin: 0,
});

export const tabPanelStack = css({
  display: 'grid',
  // All tab panels occupy the same grid cell — the cell sizes to the tallest
  // panel's collapsed content, so switching tabs never causes layout jump.
  gridTemplateAreas: '"stack"',
  marginTop: '2x',
});

export const tabPanel = css({
  gridArea: 'stack',
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const tabPanelInactive = css({
  visibility: 'hidden',
  pointerEvents: 'none',
});

export const schoolList = css({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
});

export const schoolItem = css({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  alignItems: 'center',
  gap: '2x',
  paddingTop: '2x',
  paddingBottom: '2x',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'rgba(209, 209, 214, 0.50)',
  '&:first-of-type': {
    borderTopWidth: 0,
    paddingTop: 0,
  },
});

export const schoolItemFocusTarget = css({
  outline: 'none',
});

export const schoolBody = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
  minWidth: 0,
});

export const schoolName = css({
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxBlue500',
  fontWeight: 'bold',
  margin: 0,
});

export const link = css({
  color: 'hpxTeal500',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '4px',
  },
});

export const schoolMeta = css({
  fontSize: 'sm',
  lineHeight: 'sm',
  color: 'hpxGrey600',
  margin: 0,
});

export const schoolDistance = css({
  fontSize: 'sm',
  lineHeight: 'sm',
  color: 'hpxGrey600',
  whiteSpace: 'nowrap',
});

export const showingMessage = css({
  fontSize: 'tiny',
  lineHeight: 'sm',
  color: 'hpxGrey600',
  margin: 0,
});

export const showMoreButton = css({
  alignSelf: 'flex-start',
  background: 'transparent',
  border: 'none',
  padding: 0,
  fontSize: 'sm',
  lineHeight: 'sm',
  color: 'hpxTeal500',
  fontWeight: '600',
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '4px',
  },
});

export const disclaimer = css({
  fontSize: 'tiny',
  lineHeight: 'sm',
  color: 'hpxGrey600',
  margin: 0,
});

export const disclaimerTrigger = css({
  background: 'transparent',
  border: 'none',
  padding: 0,
  fontSize: 'tiny',
  lineHeight: 'sm',
  color: 'hpxTeal500',
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '4px',
  },
});

export const disclaimerPanel = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '3x',
  padding: '4x',
});

export const disclaimerHeading = css({
  fontSize: 'lg',
  lineHeight: 'lg',
  color: 'hpxBlue500',
  fontWeight: 'bold',
  margin: 0,
});

export const disclaimerSection = css({
  fontSize: 'sm',
  lineHeight: 'md',
  color: 'hpxBlue500',
  margin: 0,
});

export const srOnly = css({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
});
